import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['section-title', {
      selected: $props.selected
    }]),
    style: _normalizeStyle($props.color ? {
      color: $props.color
    } : null)
  }, [$props.searching || $props.selected || $props.showCount ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "count",
    style: _normalizeStyle($props.countColor ? {
      color: $props.countColor
    } : null)
  }, _toDisplayString($props.count), 5)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.formattedTitle), 1)], 6);
}